module.exports = __webpack_public_path__ + "static/media/row.73b3e506.png";